import React, { useState, useEffect } from "react";
import AnimatedPageContainer from "../../../assets/containers/AnimatedPageContainer";
import CustomButton from "../../../assets/components/CustomButton";
import { useNavigate, useParams } from "react-router-dom";
import appApi from "../../../assets/utils/AppApi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import Loading from "../../../assets/containers/loadingDialog";
import classes from "../styles/style.module.css";

import { FaPen } from "react-icons/fa";
import { MdAccountBalance } from "react-icons/md";
import ListAltIcon from "@material-ui/icons/ListAlt";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import HelpIcon from "@material-ui/icons/Help";
import ImportContactsIcon from "@material-ui/icons/ImportContacts";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import PermIdentityIcon from "@material-ui/icons/PermIdentity";
import PostAddIcon from "@material-ui/icons/PostAdd";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import CreateOutlinedIcon from "@material-ui/icons/CreateOutlined";
import ContactPhoneOutlinedIcon from "@material-ui/icons/ContactPhoneOutlined";
import ContactSupportOutlinedIcon from "@material-ui/icons/ContactSupportOutlined";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import LocalLibraryOutlinedIcon from "@material-ui/icons/LocalLibraryOutlined";
import BookmarkBorderOutlinedIcon from "@material-ui/icons/BookmarkBorderOutlined";
import { baseURL } from "../../../assets/constants/baseUrl";

const EventDetails = () => {
  const [loading, setLoading] = useState(false);
  const [hasTicket, setHasTicket] = useState(null);
  const [event, setevent] = useState(null);

  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    checkHasTicket();
    getEventById();
  }, []);

  const clickHandler = () => {
    if (!loading) {
      if (hasTicket === null) {
        navigate(`/events/${id}`);
      } else {
        navigate(`/ticket/${hasTicket._id}`, { replace: true });
      }
    }
  };

  const checkHasTicket = async () => {
    setLoading(true);
    try {
      await appApi
        .post(`/eventTicket/getMyTicket`, {
          eventId: id,
        })
        .then(({ data }) => {
          setHasTicket(data.ticket);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const getEventById = async () => {
    setLoading(true);
    try {
      await appApi.get(`/event/getsingle/${id}`).then(({ data }) => {
        setevent(data.event);
        setLoading(false);
      });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const getFormIcon = (icon) => {
    let formIcon = null;
    if (icon === "first") {
      formIcon = <MdAccountBalance fontSize={"50"} color="#FF9B14" />;
    } else if (icon === "second") {
      formIcon = <FaPen fontSize={"50"} color="#FF9B14" />;
    } else if (icon === "second") {
      formIcon = <FaPen fontSize={"50"} color="#FF9B14" />;
    } else if (icon === "third") {
      formIcon = <ListAltIcon style={{ color: "#FF9B14", fontSize: "50px" }} />;
    } else if (icon === "forth") {
      formIcon = (
        <HelpOutlineIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "fifth") {
      formIcon = <HelpIcon style={{ color: "#FF9B14", fontSize: "50px" }} />;
    } else if (icon === "sixth") {
      formIcon = (
        <ImportContactsIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "seventh") {
      formIcon = (
        <MenuBookIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "eighth") {
      formIcon = (
        <CreditCardIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "ninth") {
      formIcon = (
        <PermIdentityIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "thenth") {
      formIcon = <PostAddIcon style={{ color: "#FF9B14", fontSize: "50px" }} />;
    } else if (icon === "twelveth") {
      formIcon = (
        <CreateOutlinedIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "thirteenth") {
      formIcon = (
        <KeyboardArrowDownIcon style={{ color: "#FF9B14", fontSize: "50px" }} />
      );
    } else if (icon === "thirteenth") {
      formIcon = <HelpIcon style={{ color: "#FF9B14", fontSize: "50px" }} />;
    } else if (icon === "forteenth") {
      formIcon = (
        <ContactPhoneOutlinedIcon
          style={{ color: "#FF9B14", fontSize: "50px" }}
        />
      );
    } else if (icon === "fifteenth") {
      formIcon = (
        <ContactSupportOutlinedIcon
          style={{ color: "#FF9B14", fontSize: "50px" }}
        />
      );
    } else if (icon === "sixteenth") {
      formIcon = (
        <PermIdentityOutlinedIcon
          style={{ color: "#FF9B14", fontSize: "50px" }}
        />
      );
    } else if (icon === "seventeenth") {
      formIcon = (
        <LocalLibraryOutlinedIcon
          style={{ color: "#FF9B14", fontSize: "50px" }}
        />
      );
    } else if (icon === "eigtheen") {
      formIcon = (
        <BookmarkBorderOutlinedIcon
          style={{ color: "#FF9B14", fontSize: "50px" }}
        />
      );
    }
    return formIcon;
  };

  return (
    <AnimatedPageContainer>
      <div className="customContainer">
        {loading ? (
          <div className="w-100 d-flex justify-content-center py-5 my-5">
            <Loading size={30} />
          </div>
        ) : (
          event && (
            <>
              <div className="w-100 d-flex justify-content-center pt-5 pb-3">
                {getFormIcon(event.icon)}
              </div>
              <p className={classes.title}>{event.name}</p>
              <p className={classes.formSubtitle}>{event.subtitle}</p>
              {event.poster ? (
                <img
                  src={`${baseURL}file/get/${event.poster}`}
                  crossOrigin="anonymous"
                  alt="poster"
                  className="w-100 img-fluid my-4 borderRadius"
                />
              ) : null}
              <div
                className={classes.formDesc}
                dangerouslySetInnerHTML={{
                  __html: event.description
                    .replace(/\n/g, "<br>")     
                    .replace(/  /g, "&nbsp;&nbsp;") 
                }}
              ></div>

              <CustomButton
                text={"مرحله بعد"}
                color={"primary"}
                clickHandler={clickHandler}
                styles={{ marginBlock: "30px" }}
              />
            </>
          )
        )}
      </div>
    </AnimatedPageContainer>
  );
};

export default EventDetails;
